import React from 'react';

const Templates = () => {
  return (
    <div>
      <h1>Templates</h1>
    </div>
  );
};

export default Templates;
